module.exports = __webpack_public_path__ + "images/pc-bottom-dark.f8f26ab6.png";